"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridNew = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@veeam/core");
const controls_1 = require("../controls");
const IgnoreSvg_1 = require("../DataGrid/icons/IgnoreSvg");
const RefreshSvg_1 = require("../DataGrid/icons/RefreshSvg");
const useDataGridNewNotification_1 = require("./hooks/useDataGridNewNotification");
const useThrottleTime_1 = require("./hooks/useThrottleTime");
const interactor_1 = require("./interactor");
const types_1 = require("./types");
const GridCore_1 = require("../GridCore");
const columnMoving_1 = require("../GridCore/plugins/columnMoving");
const gridColumnResizePlugin_1 = require("../GridCore/plugins/columnResize/gridColumnResizePlugin");
const columnShownState_1 = require("../GridCore/plugins/columnShownState");
const expandCollapse_1 = require("../GridCore/plugins/expandCollapse");
const multiSelection_1 = require("../GridCore/plugins/multiSelection");
const normal_1 = require("../GridCore/plugins/normal");
const notification_1 = require("../GridCore/plugins/notification");
const selectionDecorator_1 = require("../GridCore/plugins/selectionDecorator");
const singleSelection_1 = require("../GridCore/plugins/singleSelection");
const subheader_1 = require("../GridCore/plugins/subheader");
const gridHeaderCell_1 = require("../GridCore/renderers/gridHeaderCell");
const gridNormalCell_1 = require("../GridCore/renderers/gridNormalCell");
const useDisableScroll_1 = require("../helpers/useDisableScroll");
const icons_1 = require("../icons");
const layouts_1 = require("../layouts");
const collectionContextMenu_1 = require("../smart/collectionContextMenu");
const collectionToolbar_1 = require("../smart/collectionToolbar");
function DataGridNew({ model, disabled, loading, toolbar, columns, config, flags = {}, texts, fragment, isRowDisabled, isRowInactive, isSelectionAllowed, apiController, disabledSelection, onRowClick, onRowDoubleClick, grouping, pagination = types_1.DATA_GRID_NEW_PAGINATION.page, ['data-selector-id']: dataSelectorId }) {
    const { showNotification, dismissNotification, notificationContent, canCloseNotification } = (0, useDataGridNewNotification_1.useDataGridNewNotification)();
    const gridApi = (0, react_1.useMemo)(() => {
        return {
            showNotification,
            dismissNotification
        };
    }, [dismissNotification, showNotification]);
    const isPagePagination = (0, react_1.useMemo)(() => pagination === types_1.DATA_GRID_NEW_PAGINATION.page, [pagination]);
    const isServerSidePagination = (0, react_1.useMemo)(() => pagination === types_1.DATA_GRID_NEW_PAGINATION.serverSide, [pagination]);
    const [supressMetaLoading, setSupressMetaLoading] = (0, react_1.useState)(false);
    const interactorBuilder = (0, react_1.useCallback)(() => {
        var _a;
        return new interactor_1.DataGridNewInteractor(model, {
            autoLoad: (_a = config === null || config === void 0 ? void 0 : config.autoLoad) !== null && _a !== void 0 ? _a : true,
            persistent: config === null || config === void 0 ? void 0 : config.persistent,
            hasNoneSort: config === null || config === void 0 ? void 0 : config.hasNoneSort,
            isRowDisabled,
            isSelectionAllowed,
            isPagePagination,
            supressMetaLoading: (value) => {
                setSupressMetaLoading(value);
            }
        });
    }, [
        config === null || config === void 0 ? void 0 : config.autoLoad,
        config === null || config === void 0 ? void 0 : config.hasNoneSort,
        config === null || config === void 0 ? void 0 : config.persistent,
        isPagePagination,
        isRowDisabled,
        isSelectionAllowed,
        model
    ]);
    const { interactor } = (0, core_1.useInteractor)(interactorBuilder);
    (0, react_1.useEffect)(() => {
        interactor.updateConfig({ isRowDisabled, isSelectionAllowed, isPagePagination });
    }, [interactor, isRowDisabled, isSelectionAllowed, isPagePagination]);
    const showOutdatedNotification = (0, react_1.useCallback)(() => {
        gridApi === null || gridApi === void 0 ? void 0 : gridApi.showNotification({
            icon: react_1.default.createElement(icons_1.LargeInfoStatusIcon, null),
            content: (texts === null || texts === void 0 ? void 0 : texts.outdatedNotificationMessage) || 'Grid data is outdated',
            canClose: !(config === null || config === void 0 ? void 0 : config.hideIgnoreActionOfOutdatedNotification),
            onDidClose: () => {
                interactor.didSelectIgnoreFreshData();
            },
            actions: [
                {
                    icon: react_1.default.createElement(RefreshSvg_1.RefreshSvg, null),
                    text: (texts === null || texts === void 0 ? void 0 : texts.outdatedNotificationRefreshAction) || 'Refresh',
                    handler: () => {
                        interactor.didSelectApplyFreshData();
                    }
                },
                {
                    icon: react_1.default.createElement(IgnoreSvg_1.IgnoreSvg, null),
                    text: (texts === null || texts === void 0 ? void 0 : texts.outdatedNotificationIgnoreAction) || 'Ignore',
                    handler: () => interactor.didSelectIgnoreFreshData(),
                    hidden: config === null || config === void 0 ? void 0 : config.hideIgnoreActionOfOutdatedNotification
                }
            ]
        });
    }, [
        config === null || config === void 0 ? void 0 : config.hideIgnoreActionOfOutdatedNotification,
        gridApi,
        interactor,
        texts === null || texts === void 0 ? void 0 : texts.outdatedNotificationIgnoreAction,
        texts === null || texts === void 0 ? void 0 : texts.outdatedNotificationMessage,
        texts === null || texts === void 0 ? void 0 : texts.outdatedNotificationRefreshAction
    ]);
    const presenterDismissNotification = (0, react_1.useCallback)(() => {
        gridApi.dismissNotification();
    }, [gridApi]);
    interactor.presenter = (0, react_1.useMemo)(() => {
        return {
            showOutdatedNotification,
            dismissNotification: presenterDismissNotification
        };
    }, [presenterDismissNotification, showOutdatedNotification]);
    const [, setResizeState] = (0, react_1.useState)({});
    const [, setOrderState] = (0, react_1.useState)({});
    const [columnShownState, setColumnShownState] = (0, react_1.useState)({});
    const idGetter = (0, react_1.useCallback)((item) => model.getItemID(item), [model]);
    const { value, meta } = (0, core_1.useModel)(model);
    const data = (0, react_1.useMemo)(() => value.items, [value.items]);
    const groupingValue = (0, react_1.useMemo)(() => value.grouping, [value.grouping]);
    const getIndexWithOffset = (0, react_1.useCallback)((index, shouldAdd) => {
        if (value.pagination && isServerSidePagination) {
            const offset = value.prevOffset || 0;
            if (shouldAdd) {
                return index + offset;
            }
            return index - offset;
        }
        return index;
    }, [isServerSidePagination, value.pagination, value.prevOffset]);
    const getDataByIndex = (0, react_1.useCallback)((index) => {
        var _a;
        const idx = getIndexWithOffset(index);
        return (_a = data[idx]) !== null && _a !== void 0 ? _a : null;
    }, [data, getIndexWithOffset]);
    if (apiController) {
        apiController.injectApi(gridApi);
    }
    (0, react_1.useEffect)(() => {
        return () => {
            apiController === null || apiController === void 0 ? void 0 : apiController.destroy();
        };
    }, [apiController]);
    const ref = (0, react_1.useRef)(null);
    (0, useDisableScroll_1.useDisableScroll)({
        activate: disabled,
        ref
    });
    const persistConfig = interactor.getPersistConfig();
    const internalLoading = (0, react_1.useMemo)(() => loading || (meta.loading && !supressMetaLoading), [loading, meta.loading, supressMetaLoading]);
    const sorting = (0, react_1.useMemo)(() => value.sorting[0], [value.sorting]);
    const columnJustify = (0, react_1.useCallback)((justify) => {
        return justify === types_1.DATA_GRID_NEW_COLUMN_JUSTIFY.right
            ? GridCore_1.COLUMN_CONTENT_JUSTIFY.end
            : GridCore_1.COLUMN_CONTENT_JUSTIFY.start;
    }, []);
    const cellJustify = (0, react_1.useCallback)((justify) => {
        return justify === GridCore_1.COLUMN_CONTENT_JUSTIFY.end
            ? types_1.DATA_GRID_NEW_COLUMN_JUSTIFY.right
            : types_1.DATA_GRID_NEW_COLUMN_JUSTIFY.left;
    }, []);
    const columnsConfig = (0, react_1.useMemo)(() => {
        return columns
            .filter((column) => {
            var _a;
            if ((config === null || config === void 0 ? void 0 : config.columnsToggleable) && ((_a = column.canToggleable) !== null && _a !== void 0 ? _a : true)) {
                return true;
            }
            return !column.hidden;
        })
            .map((column) => {
            var _a;
            return {
                id: column.id,
                width: (_a = persistConfig.columnSizes[column.id]) !== null && _a !== void 0 ? _a : column.width,
                order: persistConfig.columnOrders[column.id],
                minWidth: column.minWidth,
                flex: column.flex,
                justify: columnJustify(column.justify),
                highlighted: column.highlighted,
                header: (payload) => {
                    var _a, _b;
                    return (0, gridHeaderCell_1.gridHeaderCell)({
                        title: (_b = (_a = column.headerCellContent) === null || _a === void 0 ? void 0 : _a.call(column)) !== null && _b !== void 0 ? _b : column.title,
                        content: () => {
                            var _a, _b;
                            return ((_b = (_a = column.headerCell) === null || _a === void 0 ? void 0 : _a.call(column, {
                                id: column.id,
                                title: column.title,
                                justify: cellJustify(payload.column.justify),
                                isTotalColumn: !!column.highlighted,
                                minWidth: column.minWidth,
                                width: payload.column.width,
                                sortKey: column.sortKey,
                                highlighted: !!column.highlighted
                            })) !== null && _b !== void 0 ? _b : null);
                        },
                        onClick: column.sortKey && !column.onHeaderClick
                            ? () => {
                                column.sortKey &&
                                    interactor.toggleSort(column.sortKey, column.sortCollation, column === null || column === void 0 ? void 0 : column.firstSortDirection);
                            }
                            : column.onHeaderClick,
                        sorting: (sorting === null || sorting === void 0 ? void 0 : sorting.key) && column.sortKey === (sorting === null || sorting === void 0 ? void 0 : sorting.key)
                            ? sorting === null || sorting === void 0 ? void 0 : sorting.direction
                            : undefined,
                        clickable: config === null || config === void 0 ? void 0 : config.canOrderedColumns,
                        highlighted: column.highlighted
                    })(payload);
                },
                cell: (payload) => {
                    return (0, gridNormalCell_1.gridNormalCell)({
                        value: () => column.cell(payload.rowData, {
                            rowData: payload.rowData,
                            rowIndex: payload.rowIndex,
                            columnWidth: payload.column.width,
                            justify: cellJustify(payload.column.justify),
                            inactive: payload.inactive,
                            disabled: payload.disabled,
                            highlighted: payload.column.highlighted
                        })
                    })(payload);
                }
            };
        });
    }, [
        columns,
        config === null || config === void 0 ? void 0 : config.columnsToggleable,
        config === null || config === void 0 ? void 0 : config.canOrderedColumns,
        persistConfig.columnSizes,
        persistConfig.columnOrders,
        columnJustify,
        sorting === null || sorting === void 0 ? void 0 : sorting.key,
        sorting === null || sorting === void 0 ? void 0 : sorting.direction,
        cellJustify,
        interactor
    ]);
    const selectedItems = (0, react_1.useMemo)(() => {
        const filteredItems = [];
        for (let i = 0; i < value.selection.length; i++) {
            const itemId = value.selection[i];
            const item = model.getItemById(itemId);
            const itemIndex = data.findIndex((element) => element === item);
            if (item &&
                !(isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled({
                    rowData: item,
                    rowIndex: getIndexWithOffset(itemIndex, true),
                    id: itemId
                }))) {
                filteredItems.push(item);
            }
        }
        return filteredItems;
    }, [data, getIndexWithOffset, isRowDisabled, model, value.selection]);
    const paginationFooter = (0, react_1.useMemo)(() => {
        if ((config === null || config === void 0 ? void 0 : config.forcePaginationShownState) === false) {
            return null;
        }
        if ((interactor.hasPagination() || (config === null || config === void 0 ? void 0 : config.forcePaginationShownState)) &&
            value.pagination &&
            isPagePagination) {
            const lastPage = Math.ceil((value.totalCount || data.length) / value.pagination.limit);
            const activePage = value.pagination.offset / value.pagination.limit + 1;
            if (lastPage < activePage) {
                interactor.didPageChange(lastPage);
            }
            return (react_1.default.createElement(controls_1.Pagination, { style: { alignSelf: 'center' }, activePage: activePage, lastPage: lastPage, disabled: disabled, onPageChange: interactor.didPageChange.bind(interactor), onPageClick: interactor.didPageChange.bind(interactor), texts: texts === null || texts === void 0 ? void 0 : texts.pagination }));
        }
        return null;
    }, [
        config === null || config === void 0 ? void 0 : config.forcePaginationShownState,
        interactor,
        value.pagination,
        value.totalCount,
        isPagePagination,
        data.length,
        disabled,
        texts === null || texts === void 0 ? void 0 : texts.pagination
    ]);
    const totalItemsCount = (0, react_1.useMemo)(() => {
        var _a;
        if (isPagePagination) {
            return data.length;
        }
        return (_a = value.totalCount) !== null && _a !== void 0 ? _a : 0;
    }, [isPagePagination, value.totalCount, data.length]);
    const toolbarPayloadGetter = (0, react_1.useCallback)(() => ({
        selectedItems,
        loading: internalLoading,
        flags,
        totalItemsCount
    }), [flags, internalLoading, selectedItems, totalItemsCount]);
    const { element: toolbarElement, contextMenuActions } = (0, react_1.useMemo)(() => (0, collectionToolbar_1.buildCollectionToolbar)({
        config: toolbar,
        model: model,
        buildIn: config === null || config === void 0 ? void 0 : config.buildIn,
        payloadGetter: toolbarPayloadGetter
    }), [config === null || config === void 0 ? void 0 : config.buildIn, model, toolbar, toolbarPayloadGetter]);
    const contextMenuPayloadGetter = (0, react_1.useCallback)(() => ({ selectedItems: selectedItems, loading: internalLoading, flags }), [flags, internalLoading, selectedItems]);
    const contextMenuItems = (0, react_1.useMemo)(() => contextMenuActions.map((item) => {
        return {
            id: item.id,
            title: item.title || '',
            icon: item.icon,
            decorators: item.decorators,
            disabled: item.disabled,
            hidden: item.hidden,
            handler: () => { var _a; return (_a = item.handler) === null || _a === void 0 ? void 0 : _a.call(item); },
            items: item.items
        };
    }), [contextMenuActions]);
    const contextMenu = (0, collectionContextMenu_1.useContextMenu)({
        items: contextMenuItems,
        payloadGetter: contextMenuPayloadGetter
    });
    const plugins = [];
    const handleRowDisabled = (0, react_1.useCallback)((index) => {
        var _a;
        const data = getDataByIndex(index);
        return (data &&
            ((_a = isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled({
                rowIndex: index,
                rowData: data,
                id: idGetter(data)
            })) !== null && _a !== void 0 ? _a : false));
    }, [getDataByIndex, idGetter, isRowDisabled]);
    const handleRowInactive = (0, react_1.useCallback)((index) => {
        var _a;
        const data = getDataByIndex(index);
        return (data &&
            ((_a = isRowInactive === null || isRowInactive === void 0 ? void 0 : isRowInactive({
                rowIndex: index,
                rowData: data,
                id: idGetter(data)
            })) !== null && _a !== void 0 ? _a : false));
    }, [getDataByIndex, idGetter, isRowInactive]);
    const usePlugin = (getPlugin) => {
        plugins.push((0, react_1.useMemo)(() => { var _a; return (_a = getPlugin()) !== null && _a !== void 0 ? _a : (() => ({})); }, [getPlugin]));
    };
    usePlugin((0, react_1.useCallback)(() => (0, normal_1.gridNormalPlugin)({
        headless: config === null || config === void 0 ? void 0 : config.headless,
        rowHeightGetter: (config === null || config === void 0 ? void 0 : config.rowHeight) ? () => (config === null || config === void 0 ? void 0 : config.rowHeight) || 0 : undefined,
        isLoading: internalLoading,
        isEmpty: !internalLoading && !data.length,
        emptyRenderer: config === null || config === void 0 ? void 0 : config.emptyRenderer,
        disabled,
        isRowInactive: handleRowInactive,
        isRowDisabled: handleRowDisabled,
        texts: {
            empty: texts === null || texts === void 0 ? void 0 : texts.empty
        }
    }), [
        config === null || config === void 0 ? void 0 : config.headless,
        config === null || config === void 0 ? void 0 : config.rowHeight,
        config === null || config === void 0 ? void 0 : config.emptyRenderer,
        internalLoading,
        data.length,
        disabled,
        handleRowInactive,
        handleRowDisabled,
        texts === null || texts === void 0 ? void 0 : texts.empty
    ]));
    usePlugin((0, react_1.useCallback)(() => notificationContent
        ? (0, notification_1.gridNotificationPlugin)({
            onRequestClose: canCloseNotification ? dismissNotification : undefined,
            content: notificationContent
        })
        : null, [canCloseNotification, dismissNotification, notificationContent]));
    usePlugin((0, react_1.useCallback)(() => {
        var _a, _b, _c;
        if (!(config === null || config === void 0 ? void 0 : config.columnsToggleable)) {
            return null;
        }
        const menu = [];
        const { columnVisibility, columnOrders } = persistConfig;
        const getColumns = () => {
            if (Object.keys(columnOrders).length === 0) {
                return columns;
            }
            return columns.sort((a, b) => {
                const indexA = columnOrders[a.id] || columns.indexOf(a);
                const indexB = columnOrders[b.id] || columns.indexOf(a);
                return indexA - indexB;
            });
        };
        const columnsList = getColumns();
        for (let i = 0; i < columnsList.length; i++) {
            const col = columnsList[i];
            if ((_a = col.canToggleable) !== null && _a !== void 0 ? _a : true) {
                const shownStateValue = (_c = (_b = columnShownState[col.id]) !== null && _b !== void 0 ? _b : columnVisibility[col.id]) !== null && _c !== void 0 ? _c : !col.hidden;
                menu.push({
                    id: col.id,
                    title: col.title,
                    value: shownStateValue,
                    onClick: () => {
                        var _a;
                        interactor.didColumnVisibilityChange({
                            columnId: col.id,
                            isShown: !shownStateValue
                        });
                        const columnOrders = persistConfig.columnOrders;
                        interactor.didColumnOrderChange(Object.assign(Object.assign({}, columnOrders), { [col.id]: (_a = columnOrders[col.id]) !== null && _a !== void 0 ? _a : i }));
                        setColumnShownState(Object.assign(Object.assign({}, columnShownState), { [col.id]: !shownStateValue }));
                    }
                });
            }
        }
        return (0, columnShownState_1.gridColumnShownStatePlugin)({
            menu
        });
    }, [columnShownState, columns, config === null || config === void 0 ? void 0 : config.columnsToggleable, interactor, persistConfig]));
    const isSelected = (0, react_1.useCallback)((index) => {
        const selectedId = value.selection[0];
        if (typeof selectedId === 'undefined') {
            return false;
        }
        const item = getDataByIndex(index);
        if (!item) {
            return false;
        }
        const itemId = idGetter(item);
        if (isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled({
            rowData: item,
            rowIndex: index,
            id: itemId
        })) {
            return false;
        }
        return value.selection.includes(idGetter(item));
    }, [value.selection, getDataByIndex, idGetter, isRowDisabled]);
    const isMultiSelectionEnabled = (0, react_1.useMemo)(() => (config === null || config === void 0 ? void 0 : config.selection) && typeof config.selection !== 'boolean' && config.selection.multi, [config === null || config === void 0 ? void 0 : config.selection]);
    const canSelect = (0, react_1.useCallback)((index) => !disabledSelection && !handleRowDisabled(index), [disabledSelection, handleRowDisabled]);
    usePlugin((0, react_1.useCallback)(() => {
        var _a;
        const isSelectionNotDefined = typeof (config === null || config === void 0 ? void 0 : config.selection) === 'undefined';
        const isSelectionDefinedAsSingle = (config === null || config === void 0 ? void 0 : config.selection) === true ||
            (typeof (config === null || config === void 0 ? void 0 : config.selection) !== 'boolean' && !((_a = config === null || config === void 0 ? void 0 : config.selection) === null || _a === void 0 ? void 0 : _a.multi));
        if ((disabledSelection && isSelectionNotDefined) || isSelectionDefinedAsSingle) {
            return (0, singleSelection_1.gridSingleSelectionPlugin)({
                isSelected,
                onRowDoubleClick: (index) => {
                    const rowData = getDataByIndex(index);
                    onRowDoubleClick === null || onRowDoubleClick === void 0 ? void 0 : onRowDoubleClick({
                        rowIndex: index,
                        rowData,
                        id: idGetter(rowData)
                    });
                },
                onRowClick: (index) => {
                    const rowData = getDataByIndex(index);
                    onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick({
                        rowIndex: index,
                        rowData,
                        id: idGetter(rowData)
                    });
                },
                onSelect: (index) => {
                    if (!canSelect(index)) {
                        return;
                    }
                    interactor.didSelectionChange([idGetter(getDataByIndex(index))]);
                },
                onContextMenu: (index, e) => {
                    if (!canSelect(index)) {
                        return;
                    }
                    interactor.didSelectionChange([idGetter(getDataByIndex(index))]);
                    if (!(config === null || config === void 0 ? void 0 : config.disableContextMenu)) {
                        contextMenu.show({
                            offsetX: e.pageX,
                            offsetY: e.pageY
                        });
                    }
                }
            });
        }
        return null;
    }, [
        config === null || config === void 0 ? void 0 : config.selection,
        config === null || config === void 0 ? void 0 : config.disableContextMenu,
        disabledSelection,
        isSelected,
        getDataByIndex,
        onRowDoubleClick,
        idGetter,
        onRowClick,
        canSelect,
        interactor,
        contextMenu
    ]));
    usePlugin((0, react_1.useCallback)(() => {
        var _a;
        if ((config === null || config === void 0 ? void 0 : config.selection) &&
            typeof config.selection !== 'boolean' &&
            config.selection.multi) {
            const selection = config.selection;
            return (0, multiSelection_1.gridMultiSelectionPlugin)({
                hasCheckbox: (_a = selection.withCheckbox) !== null && _a !== void 0 ? _a : true,
                selectAllEnabled: isPagePagination,
                subheader: selection.subheaderRenderer === null
                    ? null
                    : selection.subheaderRenderer || {
                        getSelected: () => value.selection.length,
                        getTotal: () => value.totalCount || data.length,
                        texts: texts === null || texts === void 0 ? void 0 : texts.selectionSubheader
                    },
                onRowDoubleClick: (index) => {
                    const rowData = getDataByIndex(index);
                    onRowDoubleClick === null || onRowDoubleClick === void 0 ? void 0 : onRowDoubleClick({
                        rowIndex: index,
                        rowData,
                        id: idGetter(rowData)
                    });
                },
                onRowClick: (index) => {
                    const rowData = getDataByIndex(index);
                    onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick({
                        rowIndex: index,
                        rowData,
                        id: idGetter(rowData)
                    });
                },
                onMultiSelect: (index, isShift) => {
                    if (!canSelect(index)) {
                        return;
                    }
                    const selection = value.selection;
                    const itemId = idGetter(getDataByIndex(index));
                    if (isShift && selection.length && isPagePagination) {
                        const edgeItemSelectedIndex = data.findIndex((i) => idGetter(i) === selection[selection.length - 1]);
                        const start = Math.min(edgeItemSelectedIndex, index);
                        const end = Math.max(edgeItemSelectedIndex, index);
                        let nextValue = [];
                        for (let i = start; i <= end; i++) {
                            if (!handleRowDisabled(i)) {
                                nextValue.push(idGetter(data[i]));
                            }
                        }
                        if (index > edgeItemSelectedIndex) {
                            nextValue = nextValue.reverse();
                        }
                        interactor.didSelectionChange(nextValue);
                        return;
                    }
                    if (selection.includes(idGetter(getDataByIndex(index)))) {
                        interactor.didSelectionChange(selection.filter((v) => v !== itemId));
                        return;
                    }
                    interactor.didSelectionChange([...selection, itemId]);
                },
                onSelect: (index) => {
                    if (!canSelect(index)) {
                        return;
                    }
                    interactor.didSelectionChange([idGetter(getDataByIndex(index))]);
                },
                onContextMenu: (index, e) => {
                    if (!canSelect(index)) {
                        return;
                    }
                    const selectedId = idGetter(getDataByIndex(index));
                    const isNotSelected = !value.selection.includes(selectedId);
                    if (isNotSelected) {
                        interactor.didSelectionChange([selectedId]);
                    }
                    if (!(config === null || config === void 0 ? void 0 : config.disableContextMenu)) {
                        contextMenu.show({
                            offsetX: e.pageX,
                            offsetY: e.pageY
                        });
                    }
                },
                onAllSelect: () => {
                    if (disabledSelection) {
                        return;
                    }
                    interactor.didSelectAllChange();
                },
                isAllSelected: () => {
                    if (interactor.isSelectAll()) {
                        return true;
                    }
                    if (interactor.isSelectSome()) {
                        return null;
                    }
                    return false;
                },
                isSelected,
                isRowDisabled: handleRowDisabled
            });
        }
        return null;
    }, [
        config === null || config === void 0 ? void 0 : config.selection,
        config === null || config === void 0 ? void 0 : config.disableContextMenu,
        isPagePagination,
        texts === null || texts === void 0 ? void 0 : texts.selectionSubheader,
        isSelected,
        handleRowDisabled,
        value.selection,
        value.totalCount,
        data,
        getDataByIndex,
        onRowDoubleClick,
        idGetter,
        onRowClick,
        canSelect,
        interactor,
        contextMenu,
        disabledSelection
    ]));
    usePlugin((0, react_1.useCallback)(() => (config === null || config === void 0 ? void 0 : config.subheader)
        ? (0, subheader_1.gridSubheaderPlugin)({
            content: config.subheader.render()
        })
        : null, [config === null || config === void 0 ? void 0 : config.subheader]));
    usePlugin((0, react_1.useCallback)(() => (config === null || config === void 0 ? void 0 : config.canOrderedColumns)
        ? (0, columnMoving_1.gridColumnMovingPlugin)({
            onChange: ({ orders }) => {
                interactor.didColumnOrderChange(orders);
                setOrderState(orders);
            }
        })
        : null, [config === null || config === void 0 ? void 0 : config.canOrderedColumns, interactor]));
    usePlugin((0, react_1.useCallback)(() => (config === null || config === void 0 ? void 0 : config.isSelectionDecoratorEnabled)
        ? (0, selectionDecorator_1.gridSelectionDecoratorPlugin)({
            isSelected,
            isMultiSelectionEnabled
        })
        : null, [config === null || config === void 0 ? void 0 : config.isSelectionDecoratorEnabled, isMultiSelectionEnabled, isSelected]));
    const getMetaByIndex = (0, react_1.useCallback)((index) => {
        const groupedItem = interactor.getGroupedItemByIndex(getIndexWithOffset(index));
        if (!groupedItem) {
            return {
                isExpandable: false,
                isExpanded: false,
                isLoading: false,
                depth: 0
            };
        }
        const { isGroup, isLoading, group: { key } } = groupedItem;
        return {
            isExpandable: isGroup,
            isExpanded: isGroup ? interactor.isGroupExpanded(key) : undefined,
            isLoading,
            depth: key.length - (isGroup ? 1 : 0)
        };
    }, [getIndexWithOffset, interactor]);
    const onExpandableRowClickHandler = (0, react_1.useCallback)((index) => {
        const groupedItem = interactor.getGroupedItemByIndex(getIndexWithOffset(index));
        if (groupedItem) {
            interactor.toggleExpandedGroups(groupedItem.group.key).catch((error) => {
                console.error('Did expand group error:', error);
            });
        }
    }, [getIndexWithOffset, interactor]);
    const groupColumnConfig = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!(grouping === null || grouping === void 0 ? void 0 : grouping.groupColumnConfig)) {
            return;
        }
        const { id, width, minWidth, flex, justify, headerCellContent, title } = grouping.groupColumnConfig;
        return {
            id,
            width: (_a = persistConfig.columnSizes[id]) !== null && _a !== void 0 ? _a : width,
            minWidth: minWidth,
            flex: flex,
            justify: columnJustify(justify),
            header: (0, gridHeaderCell_1.gridHeaderCell)({
                title: (_b = headerCellContent === null || headerCellContent === void 0 ? void 0 : headerCellContent()) !== null && _b !== void 0 ? _b : title
            })
        };
    }, [columnJustify, grouping === null || grouping === void 0 ? void 0 : grouping.groupColumnConfig, persistConfig.columnSizes]);
    usePlugin((0, react_1.useCallback)(() => interactor.hasGrouping() &&
        groupingValue.length &&
        grouping &&
        (grouping === null || grouping === void 0 ? void 0 : grouping.cellRenderer)
        ? (0, expandCollapse_1.gridExpandCollapsePlugin)({
            onClick: onExpandableRowClickHandler,
            getMetaByIndex,
            cellRenderer: grouping.cellRenderer,
            columnType: grouping.columnType,
            groupColumnConfig
        })
        : null, [
        getMetaByIndex,
        groupColumnConfig,
        grouping,
        interactor,
        onExpandableRowClickHandler,
        groupingValue
    ]));
    usePlugin((0, react_1.useCallback)(() => (config === null || config === void 0 ? void 0 : config.canResizeColumns)
        ? (0, gridColumnResizePlugin_1.gridColumnResizePlugin)({
            onResize: (payload) => {
                Object.entries(payload).forEach(([key, value]) => {
                    interactor.didColumnSizeChange({
                        columnId: String(key),
                        width: value
                    });
                });
                setResizeState(payload);
            }
        })
        : null, [config === null || config === void 0 ? void 0 : config.canResizeColumns, interactor]));
    const onItemsRendered = (0, useThrottleTime_1.useThrottleTime)(interactor.onItemsRendered, isServerSidePagination, 200, { leading: false, trailing: true });
    return (react_1.default.createElement(layouts_1.GridBodyLayout, { ref: ref, "data-selector-id": dataSelectorId, toolbar: toolbarElement, fragment: react_1.default.createElement(react_1.default.Fragment, null,
            Array.isArray(toolbar === null || toolbar === void 0 ? void 0 : toolbar.fragment)
                ? toolbar === null || toolbar === void 0 ? void 0 : toolbar.fragment.map((i, idx) => (react_1.default.createElement(react_1.default.Fragment, { key: idx }, i)))
                : toolbar === null || toolbar === void 0 ? void 0 : toolbar.fragment,
            contextMenu.element,
            fragment), grid: react_1.default.createElement(GridCore_1.GridCore, { idGetter: idGetter, getDataByIndex: getDataByIndex, totalItemsCount: totalItemsCount, columns: columnsConfig, plugins: plugins, footer: paginationFooter, columnsToggleable: config === null || config === void 0 ? void 0 : config.columnsToggleable, onItemsRendered: onItemsRendered }) }));
}
exports.DataGridNew = DataGridNew;
//# sourceMappingURL=DataGridNew.js.map